{
  "SectionHint": "Sie können den ACD-Nicht-Verfügbar-Ursachencode individuell angeben, der zum Berechnen jeder der 10 verschiedenen statistischen Varianten der gesamten und durchschnittlichen Nicht-Verfügbar-ACD-Statuszeit verwendet wird. Wählen Sie die 10 Codes unten aus, für die die ACD-Statuszeitstatistik einzeln gemessen wird:",
  "NaCode01Label": "Nicht verfügbarer Code 01:",
  "NaCode02Label": "Nicht verfügbarer Code 02:",
  "NaCode03Label": "Nicht verfügbarer Code 03:",
  "NaCode04Label": "Nicht verfügbarer Code 04:",
  "NaCode05Label": "Nicht verfügbarer Code 05:",
  "NaCode06Label": "Nicht verfügbarer Code 06:",
  "NaCode07Label": "Nicht verfügbarer Code 07:",
  "NaCode08Label": "Nicht verfügbarer Code 08:",
  "NaCode09Label": "Nicht verfügbarer Code 09:",
  "NaCode10Label": "Nicht verfügbarer Code 10:",
  "UseCodeDescriptionLabel": "Verwenden Sie die Code-Beschreibung in ACD NA Code Related Stats",
  "ResetCodesHeader": "Codes zurücksetzen",
  "ResetCodesHint": "Wenn derzeit in Ihrer Telefonieumgebung ACD-Nicht-Verfügbar-Ursachencodes konfiguriert sind und sich die ersten 10 davon von den oben gezeigten aktuellen Einstellungswerten unterscheiden, können Sie auf die folgende Schaltfläche klicken, um die Einstellungswerte mit den ersten zehn erkannten Codes voreinzustellen.",
  "ResetCodesButtonText": "Codes zurücksetzen",
  "ResetCodesConfirmDialogHint": "Sind Sie sicher, dass Sie alle ACD-Statistikeinstellungen für den Grund „Nicht verfügbar“ auf die ersten 10 Codes zurücksetzen möchten, die derzeit in Ihrer Telefonieumgebung konfiguriert sind?",
  "ACDCodesLanguage_SectionHeader": "Nicht verfügbare ACD-Zeitstatistikvarianten",
  "NAME": "ACDCodesLanguage",
  "NaCode11Label": "Nicht verfügbarer Code 11:"
}